// UKR-TEC — Tactical D
// Opens the desktop header dropdown / mega menu on hover, in addition to
// the theme's existing click-to-open behaviour (native <details>/<summary>,
// handled by the header-menu custom element). Setting/removing the native
// "open" attribute reuses all of the theme's existing positioning,
// transition and outside-click logic — nothing else needs to change.
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('header-menu').forEach(function (headerMenu) {
    const details = headerMenu.querySelector('details');
    if (!details) return;

    let closeTimer = null;

    function openNow() {
      if (window.innerWidth < 990) return;
      clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    }

    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    }

    headerMenu.addEventListener('mouseenter', openNow);
    headerMenu.addEventListener('mouseleave', closeSoon);
  });
});
